import {
  getBingSearchTextPlacementStyles,
  getBingSearchTextDesktopPlacementStyles,
  getBingSearchTextMobilePlacementStyles,
} from './bing-search-ad-placements-styles';
import type { UAPStyleMap } from '../../@types';


const getResponsiveSearchAdPlacementBaseStyles = (baseStyles: UAPStyleMap): UAPStyleMap => ({
  ...baseStyles,

  placementContentContainer: {
    ...baseStyles.placementContentContainer,

    display: 'flex',
    flexDirection: 'column',
  },

  placementInlineContainer: {
    display: 'flex',
    flexDirection: 'row',
  },

  placementCard: {
    ...baseStyles.placementCard,

    height: 'unset',
    minHeight: 'unset',
    padding: '8px 16px 16px 16px',
  },

  placementTextContainer: {
    ...baseStyles.placementTextContainer,

    cursor: 'unset',
  },

  placementLongHeadline: {
    ...baseStyles.placementLongHeadline,

    height: 'unset',
    minHeight: '28px',
  },

  placementDescriptionContainer: {
    ...baseStyles.placementDescriptionContainer,

    marginTop: '4px',
  },

  placementInlineItems: {
    ...baseStyles.placementInlineItems,

    display: 'block',

    '& *': {
      display: 'inline',
    },
  },
});


export const getResponsiveSearchAdPlacementStyles = (theme?: object): UAPStyleMap => {
  const { placementCard, ...baseStyles } = getResponsiveSearchAdPlacementBaseStyles(getBingSearchTextPlacementStyles(theme));
  const styles = {
    ...baseStyles,

    placementCard: {
      ...placementCard,

      width: '530px',
      marginBottom: '16px',
    },

    placementImage: {
      ...baseStyles.placementImage,

      margin: '8px 4px',
    },
  };
  return styles;
};


export const getResponsiveSearchAdDesktopPlacementStyles = (theme?: object): UAPStyleMap => {
  const { placementCard, ...baseStyles } = getResponsiveSearchAdPlacementBaseStyles(getBingSearchTextDesktopPlacementStyles(theme));
  const styles = {
    ...baseStyles,

    placementCard: {
      ...placementCard,

      width: '530px',
    },

    placementImage: {
      ...baseStyles.placementImage,

      margin: '8px 16px 8px 4px',
    },
  };
  return styles;
};


export const getResponsiveSearchAdMobilePlacementStyles = (theme?: object): UAPStyleMap => {
  const { placementCard, bingSearchMobilePlacementRoot, ...baseStyles } = getResponsiveSearchAdPlacementBaseStyles(getBingSearchTextMobilePlacementStyles(theme));
  const styles = {
    ...baseStyles,

    placementCard: {
      ...placementCard,

      width: '472px',
    },

    bingSearchMobilePlacementRoot: {
      ...bingSearchMobilePlacementRoot,

      width: '562px',
      marginBottom: '16px',
    },

    placementImage: {
      ...baseStyles.placementImage,

      margin: '8px 0px',
    },
  };
  return styles;
};
